export { OpenidCallbackContainer } from '@/components/pages/Auth/Openid/Callback';
